module.exports = __webpack_public_path__ + "img/full0-min.d360c4ba.png";